import { CardStackSocket } from "../../types/types";
import { CardStack } from "./CardStack";



export class TableStack extends CardStack
{
    public Init(): void
    {
        
    }

    /**
     * 
     * @param playerIndex 0=top, 1=right, 2=bot, 3=left
     */
    public GetSocket(playerIndex: number): CardStackSocket
    {
        // TODO: use template 
        // const socketTemplate: CardStackSocket = this.cardStackSocketTemplates[playerIndex];
        // return new random socket
        return {
            posX: Phaser.Math.FloatBetween(-20,20),
            posY: Phaser.Math.FloatBetween(-20,20),
            angle: Phaser.Math.FloatBetween(-15,15),
        }
    }

    /**
     * 
     * @param card 
     * @param position Use @see GetSocket to position at position.
     */
    // public override DropCard(card: Card, position: Phaser.Geom.Point = undefined): void
    // {
    //     super.DropCard(card, position);
    // }

    // public override PickCard(card:Card): Card | null
    // {
        
    // }
    
    // protected OnResize(windowRect: RectSize): void
    // {
    //     // console.log("TableStack::OnResize");
    //     // console.log(windowRect.width, windowRect.height);
    // }
}